import moment from 'moment';
import { Component } from 'react';
import { connect } from 'react-redux';
import { showError, showMessage } from '../../actions/uiActions';
import EinApi from '../../api/eins';
import TerminationDeleteConfirmationModal from '../../containers/Eins/terminationDeleteConfirmationModal';


class TerminationNotice extends Component
{
    state = {
        removing: false,
        confirmTermDelete: false,
    }
    delete = (excludeUserFromCensus = false) =>
    {
        const user = this.props.account
        this.setState({ removing: true }, () =>
        {
            if (user.terminatedDate)
            {
                EinApi.removeTerminatedUser(user._id, user.domain, excludeUserFromCensus).then(success =>
                {
                    const defaultMessage = excludeUserFromCensus ? 'Borrower was removed from the termination list and excluded from Census processing' : 'Borrower removed from terminated list successfully'
                    this.props.showMessage(defaultMessage);
                    this.setState({ removing: false })
                    this.props.callBack();
                }).catch(error => this.setState({ removing: false }, this.props.showError))
            } else
            {
                this.props.showMessage("User is not in the terminated list");
                this.setState({ removing: false, })
            }
        })
    }
    render()
    {
        let text = "";
        const TERMINATION_ARCHIVE_DAYS = 30
        const archiveDate = moment(this.props.account.terminatedDate, 'X').add(TERMINATION_ARCHIVE_DAYS, 'days').format('MM/DD/YYYY')
        text = `This user has been set for termination and will be automatically archived on ${archiveDate}`;
        return <div className="alert alert-danger">
            {text}<b><button onClick={() => this.setState({ confirmTermDelete: true })} disabled={this.state.removing} style={{ marginLeft: "40px" }} className={`btn btn-mini ${!this.state.removing && 'btn-secondary'}`}>{this.state.removing ? "Removing user...." : "Remove user"}</button></b>

            {this.state.confirmTermDelete && < TerminationDeleteConfirmationModal onCancel={() => this.setState({ confirmTermDelete: false })} loading={this.state.removing} action={this.delete} />}

        </div>;
    }
}
export default connect(null, { showError, showMessage })(TerminationNotice);